export default "__VITE_ASSET__BwmJcaJH__"